import React from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";

import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";

import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";

import { FiFilter, FiX } from "react-icons/fi";

import { useAdminOrderStore } from "../../store/useAdminOrderStore.ts";

const SHIPMENT_STATUS_OPTIONS = [
  { value: "", label: "همه سفارش ها" },
  { value: "PENDING_APPROVING", label: "در انتظار تایید" },
  { value: "PENDING_PROCESSING", label: "در انتظار آماده‌سازی" },
  { value: "IN_PROCESSING", label: "در حال آماده‌سازی" },
  { value: "READY_FOR_HANDOFF", label: "آماده تحویل به حمل" },
  { value: "IN_TRANSIT", label: "در حال ارسال" },
];

const DELIVERY_METHODS = [
  { value: "", label: "روش ارسال: همه" },
  {value : "supplier", label: "ارسال تأمین کننده"},
  {value : "carrier", label: "شرکت حمل"},
  {value : "pickup", label: "تحویل حضوری"},
]

const ORDERING_OPTIONS = [
  { value: "-created_at", label: "جدیدترین" },
  { value: "created_at", label: "قدیمی‌ترین" },
  { value: "subtotal_amount", label: "ارزان‌ترین" },
  { value: "-subtotal_amount", label: "گران‌ترین" },
];

const AdminOrderFilters = () => {
  const {
    activeTab,

    shipmentStatus,
    dateFrom,
    dateTo,
    minAmount,
    maxAmount,
    deliveryMethod,
    ordering,

    setFilter,
    resetFilters,
  } = useAdminOrderStore();

  const hasFilters = Boolean(
    shipmentStatus ||
      dateFrom ||
      dateTo ||
      minAmount ||
      maxAmount ||
      deliveryMethod ||
      ordering !== "-created_at"
  );

  const toGregorianDateString = (date) => {
    if (!date) return "";

    return new DateObject(date)
      .convert(gregorian, gregorian_en)
      .format("YYYY-MM-DD");
  };

  const toPersianDateObject = (value) => {
    if (!value) return "";

    return new DateObject({
      date: value,
      calendar: gregorian,
      locale: gregorian_en,
      format: "YYYY-MM-DD",
    }).convert(persian, persian_fa);
  };

  const handleDateFromChange = (date) => {
    setFilter("dateFrom", toGregorianDateString(date));
  };

  const handleDateToChange = (date) => {
    setFilter("dateTo", toGregorianDateString(date));
  };

  return (
    <section className="mb-6 rounded-xl border border-gray-100 bg-white p-4 shadow-sm sm:p-5">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
            <FiFilter size={18} />
          </span>

          <div>
            <h2 className="text-sm font-semibold text-gray-900">
              فیلتر سفارش‌ها
            </h2>

            <p className="mt-0.5 text-xs text-gray-500">
              سفارش‌ها را بر اساس وضعیت ارسال، تاریخ، مبلغ، روش ارسال و ترتیب نمایش محدود کنید.
            </p>
          </div>
        </div>

        {hasFilters && (
          <button
            type="button"
            onClick={resetFilters}
            title="پاک کردن فیلترها"
            className="
              flex h-10 w-10 items-center justify-center rounded-lg
              border border-gray-300 text-gray-500 transition-all
              hover:border-red-400 hover:bg-red-50 hover:text-red-600
            "
          >
            <FiX size={18} />
          </button>
        )}
      </div>

      <div
          className="
          grid grid-cols-1 gap-3
          sm:grid-cols-2
          xl:grid-cols-7
          items-center
        "
      >
        {activeTab === "CURRENT" && (
            <select
                value={shipmentStatus}
                onChange={(e) => setFilter("shipmentStatus", e.target.value)}
                className="
              w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5
              text-sm text-gray-800 outline-none transition
              focus:border-blue-500 focus:ring-2 focus:ring-blue-500
            "
            >
              {SHIPMENT_STATUS_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
              ))}
            </select>
        )}

        <DatePicker
            value={toPersianDateObject(dateFrom)}
            onChange={handleDateFromChange}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            placeholder="از تاریخ"
            inputClass="
            w-full rounded-lg border border-gray-300 px-3 py-2.5
            text-sm text-gray-800 outline-none transition
            focus:border-blue-500 focus:ring-2 focus:ring-blue-500
          "
            containerClassName="w-full"
        />

        <DatePicker
            value={toPersianDateObject(dateTo)}
            onChange={handleDateToChange}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            placeholder="تا تاریخ"
            inputClass="
            w-full rounded-lg border border-gray-300 px-3 py-2.5
            text-sm text-gray-800 outline-none transition
            focus:border-blue-500 focus:ring-2 focus:ring-blue-500
          "
            containerClassName="w-full"
        />

        <input
            type="number"
            value={minAmount}
            placeholder="حداقل مبلغ"
            min="0"
            onChange={(e) => setFilter("minAmount", e.target.value)}
            className="
            w-full rounded-lg border border-gray-300 px-3 py-2.5
            text-sm text-gray-800 outline-none transition
            focus:border-blue-500 focus:ring-2 focus:ring-blue-500
          "
        />

        <input
            type="number"
            value={maxAmount}
            placeholder="حداکثر مبلغ"
            min="0"
            onChange={(e) => setFilter("maxAmount", e.target.value)}
            className="
            w-full rounded-lg border border-gray-300 px-3 py-2.5
            text-sm text-gray-800 outline-none transition
            focus:border-blue-500 focus:ring-2 focus:ring-blue-500
          "
        />
        <select
            value={deliveryMethod}
            onChange={(e) => setFilter("deliveryMethod", e.target.value)}
            className="
            w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5
            text-sm text-gray-800 outline-none transition
            focus:border-blue-500 focus:ring-2 focus:ring-blue-500
          "
        >
          {DELIVERY_METHODS.map((option) => (
              <option key={option.value} value={option.value}>
                 {option.label}
              </option>
          ))}
        </select>

        <select
            value={ordering}
            onChange={(e) => setFilter("ordering", e.target.value)}
            className="
            w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5
            text-sm text-gray-800 outline-none transition
            focus:border-blue-500 focus:ring-2 focus:ring-blue-500
          "
        >
          {ORDERING_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                ترتیب: {option.label}
              </option>
          ))}
        </select>
      </div>
    </section>
  );
};

export default AdminOrderFilters;
